// Nombres de campos del formulario de recursos (imagen/video).
// Mismo patrón que interfaces/fieldNamesCreditClient.ts:
// un único diccionario de constantes para no repetir strings sueltos
// en los distintos pasos del wizard ni en el service.

export const FIELDS_NAMES_RECURSO = {
  // Organización del usuario. Opcional: filtra las estaciones disponibles.
  ORGANIZACION: 'organizacion_id',
  // Regionales. Opcionales: acotan las estaciones dentro de la organización.
  REGIONALES: 'regionales',
  // Estaciones donde se guarda el recurso (una fila por estación).
  EMPRESAS: 'empresas',
  TIPO: 'tipo_id',
  NOMBRE: 'nombre',
  URL: 'url',
  ACTIVO: 'activo',
  // Archivos seleccionados (File[]). Viven solo en el form hasta que se
  // confirma la creación: recién ahí se envían al backend, que los sube y crea
  // un recurso por cada uno.
  ARCHIVOS: 'archivos',
} as const

// Campos que se validan en cada paso del wizard (modo "crear").
// Se usan con form.validateFields(FIELDS_STEP_1) antes de avanzar de paso.
// Organización y regionales son opcionales: lo único obligatorio del paso 1 son
// las estaciones donde se guardará el recurso.
export const FIELDS_STEP_1 = [FIELDS_NAMES_RECURSO.EMPRESAS]

export const FIELDS_STEP_2 = [
  FIELDS_NAMES_RECURSO.TIPO,
  FIELDS_NAMES_RECURSO.NOMBRE,
  FIELDS_NAMES_RECURSO.ARCHIVOS,
]
